export function validateSubscriptionSettings(siteSettings) {
    const costValid = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.subscriptionCost) === undefined ? false : siteSettings.subscriptionCost > 0;
    const durationValid = (siteSettings === null || siteSettings === void 0 ? void 0 : siteSettings.subscriptionDuration) === undefined ? false : siteSettings.subscriptionDuration > 0;
    return costValid && durationValid;
}
